
import styles from './mainSection.module.css';
import { useState } from 'react';
import { Filter } from '../../ui/filter/Filter';
import { Card } from '../../ui/card/Card';
import { MarkupLayout } from '../../ui/markupLayout/MarkupLayout';
import { Button } from '../../ui/button/Button';
import { data } from '../../../constants/carFiltersPage/mock';
import { filterButtons } from '../../../constants/carFiltersPage/filterButtons';
import { useParams } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { getCatDesc } from '../../../api/category-desc-api/category-desc-api';
export function MainSection() {
  const { filter } = useParams()
  const [activeButton, setActiveButton] = useState(filter ? filter : 'airfilter');
  const filters = filterButtons(activeButton);
  const a = filters.find((item) => item.dataId === activeButton).id


  const { data } = useQuery(getCatDesc(a));

  return (
    <MarkupLayout>
      <section className={styles.mainContainer}>
        <div className={styles.filtersContainer}>
          {filters?.map((item, id) => (
            <Filter key={id} item={item} setActiveButton={setActiveButton} />
          ))}
        </div>
        <Card
          cardText1={data?.subcategory_descriptions?.description_list || []}
          image1={data?.subcategory_descriptions?.image || ''}
          image2={data?.subcategory_advantages?.image || ''}
          list={data?.subcategory_advantages?.advantages_list || []}
        />
        <Button
          width={'w-426'}
          variant={'yellow'}
          fontWeight={'bold'}
          behaviour={'link'}
          link={'/catalog'}
        >
          Каталог подбора
        </Button>
      </section>
    </MarkupLayout>
  );
}
